module.exports = __webpack_public_path__ + "assets/img/5.9ee8c2b5.png";